
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FileDto } from "@/dtos/fileDto";

@Component
export default class ImageGalleryComponent extends Vue {
	@Prop()
	private images!: FileDto[];
	@Prop()
	private isEditable!: boolean;
	private showGallery: boolean = false;
	private currentImage: number = 0;

	// @Watch('images')
	// private onImagesChanged() {
	//     this.$emit('imagesChanged', this.images);
	// }

	private getComplaintImageUrl(guid: string) {
		const uri = process.env.VUE_APP_SERVER_URL + "File/GetImage?guid=" + guid;
		return uri;
	}

	private onImageClick(index: number) {
		this.currentImage = index;
		this.showGallery = true;
	}

	private deleteImage(index: number) {
		this.images.splice(index, 1);
	}
}
